import Base from './base'

export default class Calendar extends Base {
  listEvents(params: object = {}) {
    return this.apiClient.get('calendar/events', params)
  }

  createEvent(data: object) {
    return this.apiClient.post('calendar/events', data)
  }

  updateEvent(eventId: string, patch: object, options: object = {}) {
    return this.apiClient.patch(`calendar/events/${encodeURIComponent(eventId)}`, patch, options)
  }

  deleteEvent(eventId: string) {
    return this.apiClient.delete(`calendar/events/${encodeURIComponent(eventId)}`)
  }
}
